import { createLazyComponent, LazyModule, LazyImport, LazyAction } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "InAppNotifications"*/ './lazyIndex')
);

export const NotificationPane = createLazyComponent(lazyModule, m => m.NotificationPane);

export { registerNewMailNotificationFilter } from './utils/newMailNotificationFilter';
export { registerNewLikeNotificationFilter } from './utils/newLikeNotificationFilter';
export { registerNewReactionNotificationFilter } from './utils/newReactionNotificationFilter';
export { default as onLikeNotificationClicked } from './actions/onLikeNotificationClicked';
export { default as onReactionNotificationClicked } from './actions/onReactionNotificationClicked';
export { default as onNewMailNotificationClicked } from './actions/onNewMailNotificationClicked';
export { default as onReminderClicked } from './actions/onReminderClicked';
export type { LikeNotificationData } from './store/schema/LikeNotificationData';
export type { ReactionNotificationData } from './store/schema/ReactionNotificationData';

export let lazyOnDismissAutomaticReplyNotification = new LazyImport(
    lazyModule,
    m => m.onDismissAutomaticReplyNotification
);

export let lazyRegisterNotificationHandler = new LazyAction(
    lazyModule,
    m => m.registerNotificationHandler
);
